/* eslint-disable max-len */
 
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const withStyles = require('withStyles').default
const styles = require('./pro_trial_minibar.less')
const isTryingPro = require('module/user/helpers/is_trying_pro')
const getIntersection = require('lib/get_intersection')
const radio = require('lib/radio')
const { OwnerComponent } = require('component/viewer/owner')
const log = require('log').create('trial bar') // eslint-disable-line

class ProTrialMinibar extends React.Component {

    componentDidMount() {
        this.$ = require('lib/jquery')
        require('jquery-elementquery')

        this.addElementQuery()
        this.addBeaconHider()
    }

    componentDidUpdate() {
        this.removeListeners()
        this.addElementQuery()
        this.addBeaconHider()
    }

    componentWillUnmount() {
        this.removeListeners()
    }

    addElementQuery() {
        const { user } = this.props
        if (!isTryingPro(user)) return

        // apply element query
        this.$(this.el).elementQuery([
            'min-width: 450',
        ])
    }

    addBeaconHider() {
        this.$(this.el).on('mouseenter', () => this.hideBeacon())
    }

    getOverlappingBeacon(cb) {
        const beacon = document.querySelector('iframe#launcher')
        if (!beacon) return
        const beacon_bounds = beacon.getBoundingClientRect()
        const minibar_bounds = this.el.getBoundingClientRect()
        // log('beacon_bounds', beacon_bounds)
        // log('minibar_bounds', minibar_bounds)
        // don't hide if there's no overlap
        const intersection = getIntersection(beacon_bounds, minibar_bounds)
        // log('intersection', intersection)
        if (!intersection) return
        cb(beacon)
    }

    hideBeacon() {
        this.getOverlappingBeacon((beacon) => {
            beacon.style.opacity = 0
            this.$(this.el).one('mouseleave', () => {
                beacon.style.opacity = 1
            })
        })
    }

    removeListeners() {
        if (this.$) this.$(this.el).off()
    }

    render() {
        const { user, placeholder } = this.props

        if (!isTryingPro(user)) {
            return null
        }

        const className = classNames('pro-trial-minibar', {
            placeholder,
        })

        function onClickRemove() {
            // send request to try buy controller
            radio.editpanel.request('try:buy:remove:features')
        }

        return (
            <OwnerComponent>
                <div className={className} style={{ color: '#0e5786' }} ref={(el) => { this.el = el }}>
                    <div className="upgrade-cta">
                        Pro features will be published when you <a href="/user/edit/upgrade/pro/annual" data-metric-event="try:buy:minibar:click:upgrade">upgrade.</a>
                    </div>
                    <div className="remove-cta">
                        <span className="text link" onClick={onClickRemove} data-metric-event="try:buy:minibar:click:remove">Remove Pro features</span>
                    </div>
                </div>
            </OwnerComponent>
        )
    }

}

ProTrialMinibar.propTypes = {
    user: PropTypes.object.isRequired,
    placeholder: PropTypes.bool,
}
ProTrialMinibar.defaultProps = {
    placeholder: false,
}

module.exports = withStyles(styles)(ProTrialMinibar)
